























import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';

@Component
export default class ChargeInactivatedInstancesCard extends Vue {
  @Prop({ required: true, default: '' }) private businessUnitId!: string;

  chargeInactivatedInstancesEnabled: boolean = false;

  created() {
    this.loadChargeInactivatedInstances();
  }

  @Watch('businessUnitId')
  onBusinessUnitIdChanged() {
    this.loadChargeInactivatedInstances();
  }

  loadChargeInactivatedInstances() {
    if (!this.businessUnitId) return;
    BusinessUnitService.isChargeInactivatedInstancesEnabled(this.businessUnitId)
      .then((response: boolean) => {
        this.chargeInactivatedInstancesEnabled = response;
      })
      .catch(() => {
        VbSnackbarService.handleHttpError('Erro ao carregar configuração de cobrança de instâncias inativadas.');
      });
  }

  handleSwitchChargeInactivatedInstances() {
    BusinessUnitService.switchChargeInactivatedInstances(
      this.businessUnitId,
      this.chargeInactivatedInstancesEnabled,
    )
      .then(() => {
        VbSnackbarService.showSuccess('Configuração salva com sucesso!');
      })
      .catch((err: any) => {
        this.chargeInactivatedInstancesEnabled = !this.chargeInactivatedInstancesEnabled;
        VbSnackbarService.handleHttpError(err);
      });
  }
}
